import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectAllocationSaving} from 'flows/interest/reducer';
import {loadInterestInvestment as load, submitInterestInvestment as submit} from 'flows/interest/investment/index';
import Spinner from 'components/Spinner';

import InterestInvestment from './component';

export class InterestInvestmentContainer extends React.Component {
  componentDidMount() {
    this.props.load();
  }
  render() {
    if (this.props.saving) {
      return (
        <Spinner />
      );
    }
    return (
      <InterestInvestment submit={this.props.submit} />
    );
  }
}

InterestInvestmentContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  saving: PropTypes.bool,
};

InterestInvestmentContainer.defaultProps = {
  saving: false,
};

export const mapStore = store => ({
  saving: selectAllocationSaving(store),
});

export default connect(mapStore, {load, submit})(InterestInvestmentContainer);



// WEBPACK FOOTER //
// ./web/flows/interest/investment/index.js